import React from 'react';
import { getImageChannel } from './../../../../../constants/order';
import cart from './../../../../../resources/assets/images/shopping-cart.png';
import { ListChannel } from './../../../../../constants/setting_channel';
import './styles.css';

class ChannelTable extends React.Component {
    constructor(props) {
        super(props)
    }

    handleChangeCurrentChannel(currentChannel, e) {
        e.preventDefault();
        this.props.onChangeCurrentChannel(currentChannel); 
    }
    render() {

        let listChannel = this.props.listChannel; 

        return (
            <div id="ChannelTable">
                <div className="title">
                    <img className="cart" src={cart} />
                    <span className="text-title">E-Commerce Channels</span>
                </div>
                <div className="table-operations"></div>
                <table>
                    <thead>
                        <tr>
                            <th>Channel</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className={"list-channel"}>
                                {
                                    Object.keys(listChannel).map( (keyName, i) =>  
                                        {
                                            if (!listChannel[keyName] || 
                                                !listChannel[keyName].ShortName ||
                                                listChannel[keyName].ShortName == ListChannel.Y_SHIP.ShortName
                                            ) {
                                                return null;
                                            }
                                            return <a href="#" 
                                                        key={i}
                                                        onClick={ this.handleChangeCurrentChannel.bind(this, listChannel[keyName].ShortName) }
                                                        className={(this.props.currentChannel == listChannel[keyName].ShortName) ? "item-channel item-channel-active" : "item-channel" }>
                                                        {getImageChannel(listChannel[keyName].Name)}
                                                    </a>
                                        })
                                }
                                
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }
}
export default ChannelTable


// WEBPACK FOOTER //
// ./src/containers/setting/setting-channel/components/channel-table/index.js